import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useLocation } from 'react-router-dom';
import { ApplicationDetails } from 'screens/Applications&WorkOrders/Applications/Hooks/useApplication';
import useOperationFormById from 'screens/Applications&WorkOrders/Components/hooks/useOperationFormById';
import { WorkOrderDetails } from 'screens/Applications&WorkOrders/WorkOrders/Hooks/useWorkOrders';
import StepsLayout, {
  TypeLayout
} from 'screens/Applications&WorkOrders/StepsLayout';

const DuplicateOperation: React.FC = () => {
  const { state } = useLocation();

  const { operation, operationType } = state as {
    operation: ApplicationDetails | WorkOrderDetails;
    operationType: 'application' | 'work-order';
  };
  const { setValues } = useFormikContext<any>();

  const { loading, operationFormikData } = useOperationFormById(
    operation.id,
    operationType
  );

  useEffect(() => {
    if (!loading && operationFormikData) {
      setValues(operationFormikData);
    }
  }, [loading, operationFormikData, setValues]);

  const stepLayoutType =
    operationType === 'application'
      ? TypeLayout.APPLICATION
      : TypeLayout.WORK_ORDER;

  return <StepsLayout isLoading={loading} type={stepLayoutType} />;
};

export default DuplicateOperation;
